export enum IS_PARTNER_GROUP {
  yes = 'Yes',
  no = 'No',
}
